var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { cva } from 'class-variance-authority';
import { Xmark } from 'iconoir-react';
import { classNames } from './utils';
const chipVariants = cva('inline-flex items-center justify-center font-medium w-fit whitespace-nowrap shrink-0 gap-1 transition-[color,box-shadow] overflow-hidden', {
    variants: {
        variant: {
            default: 'bg-gray-100 text-gray-700 dark:bg-base-50 dark:text-base-600',
            secondary: 'bg-gray-50 text-gray-600 dark:bg-base-50 dark:text-base-600',
            error: 'bg-red-50 text-red-700 dark:bg-error-50 dark:text-error-700',
            warning: 'bg-yellow-50 text-yellow-800 dark:bg-warning-50 dark:text-warning-700',
            success: 'bg-green-50 text-green-700 dark:bg-success-50 dark:text-success-700',
            blue: 'bg-blue-50 text-blue-700 dark:bg-blue-950 dark:text-blue-300',
            indigo: 'bg-indigo-50 text-indigo-700 dark:bg-indigo-950 dark:text-indigo-300',
            purple: 'bg-brand-50 text-brand-700',
            pink: 'bg-pink-50 text-pink-700 dark:bg-pink-950 dark:text-pink-300',
            outline: 'bg-transparent text-gray-700 ring-1 ring-inset ring-gray-300 dark:text-base-700 dark:ring-base-300',
        },
        size: {
            xs: 'px-1.5 py-0.5 text-tiny leading-tight',
            sm: 'px-1.5 py-0.5 text-xs leading-tight',
            md: 'px-2 py-1 text-xs',
            lg: 'px-2.5 py-1.5 text-sm',
        },
        rounded: {
            full: 'rounded-full',
            md: 'rounded-md',
            sm: 'rounded-sm',
            none: 'rounded-none',
        },
    },
    defaultVariants: {
        variant: 'default',
        size: 'md',
        rounded: 'md',
    },
});
function Chip(_a) {
    var { className, variant, size, rounded, label, onDelete, disabled, icon } = _a, props = __rest(_a, ["className", "variant", "size", "rounded", "label", "onDelete", "disabled", "icon"]);
    return (_jsxs("span", Object.assign({ "data-slot": "chip", className: classNames(chipVariants({ variant, size, rounded }), onDelete && 'pr-1', disabled && 'opacity-50', className) }, props, { children: [icon, _jsx("span", { className: "min-w-0 truncate", children: label }), onDelete && (_jsx("button", { type: "button", disabled: disabled, className: classNames('ml-0.5 inline-flex items-center justify-center rounded-full p-0.5', 'hover:bg-black/10 focus:outline-none focus-visible:ring-1 focus-visible:ring-gray-500 focus-visible:ring-inset dark:hover:bg-white/10', disabled && 'cursor-not-allowed'), onClick: (e) => {
                    e.stopPropagation();
                    onDelete();
                }, "aria-label": "Remove", children: _jsx(Xmark, { className: "h-3 w-3", "aria-hidden": "true" }) }))] })));
}
export default Chip;
